export default {
  /**
   * 顧客条件の標準フォーマット
   */
  get() {
    return {
      /**
       * 選択ファイル
       */
      file: undefined,
      /**
       * 顧客グループID
       */
      customerGroupId: undefined,
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(customer) {
    return {
      customerGroupId: customer.customerGroupId,
    }
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, customer) {
    // 復元データに file: {} が含まれていても File は復元できないため、
    // 常に undefined に正規化して型不整合を回避する。
    applyTo.file = undefined
    applyTo.customerGroupId = customer.customerGroupId
  },
}
